import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const ShowIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-show', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path d='M8 12.2667C4.39334 12.2667 1.58667 8.55334 1.46667 8.4L1.16667 8L1.46667 7.6C1.58667 7.44667 4.39334 3.73334 8 3.73334C11.6067 3.73334 14.4133 7.44667 14.5333 7.6L14.8333 8L14.5333 8.4C14.4133 8.55334 11.6067 12.2667 8 12.2667ZM2.86667 8C3.64001 8.88667 5.68667 10.9333 8 10.9333C10.3133 10.9333 12.36 8.88667 13.1333 8C12.36 7.11334 10.3133 5.06667 8 5.06667C5.68667 5.06667 3.64001 7.11334 2.86667 8Z' />
      <path d='M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z' />
    </svg>
  );
};

export default ShowIcon;
